import moment from 'moment';
import { ReactNode } from 'react';
import {
  Calendar,
  CalendarProps,
  DateLocalizer,
  momentLocalizer,
} from 'react-big-calendar';
import withDragAndDrop, {
  withDragAndDropProps,
} from 'react-big-calendar/lib/addons/dragAndDrop';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './MagellanCalendar.scss';
import CalendarTopbar from './topbar/CalendarTopbar';
import CalendarShowMore from './show-more/CalendarShowMore';

moment.updateLocale('pl', { week: { dow: 1 } });

const now = momentLocalizer(moment);

interface IMagellanCalendarProps<
  TEvent extends object,
  TResource extends object
> extends Omit<CalendarProps<TEvent, TResource>, 'localizer'>,
    withDragAndDropProps<TEvent, TResource> {
  localizer?: DateLocalizer;
  moreHeader?: ReactNode;
  topbarHeader?: ReactNode;
}

const MagellanCalendar = <TEvent extends object, TResource extends object>({
  localizer = now,
  defaultDate = moment().toDate(),
  defaultView = 'month',
  moreHeader,
  topbarHeader,
  ...dndCalendarProps
}: IMagellanCalendarProps<TEvent, TResource>) => {
  const DnDCalendar = withDragAndDrop<TEvent, TResource>(Calendar);

  return (
    <div className='magellan-calendar-wrapper'>
      <DnDCalendar
        formats={{
          timeGutterFormat: date => ` ${date.getHours()} `,
        }}
        localizer={localizer}
        defaultDate={defaultDate}
        defaultView={defaultView}
        views={['month']}
        resizable={false}
        draggableAccessor={() => false} // Wyłącza drag dla wszystkich wydarzeń
        resizableAccessor={() => false} // Wyłącza zmianę rozmiaru
        selectable={false} // Wyłącza zaznaczanie zakresu
        {...dndCalendarProps}
        components={{
          toolbar: props => (
            <CalendarTopbar {...props} topbarHeader={topbarHeader} />
          ),

          showMore: props => (
            <CalendarShowMore
              {...props}
              eventComponent={dndCalendarProps.components?.event}
              moreHeader={moreHeader}
            />
          ),

          ...dndCalendarProps.components,
          month: {
            // dateHeader: props => (
            //   <CalendarDateHeader {...props} freeDays={freeDays.data} />
            // ),
            ...dndCalendarProps.components?.month,
          },
        }}
        className='magellan-calendar'
      />

      {/* <div
        className={`loading-wrapper ${loading || freeDays.isLoading ? 'visible' : ''}`}>
        <Button loading variant='background' size='large'></Button>
      </div> */}
    </div>
  );
};

export default MagellanCalendar;
